enum TipoNegociacaoOferta {
  QuitacaoParcial = 'QuitacaoParcial',
  QuitacaoCompleta = 'QuitacaoCompleta',
  Novacao = 'Novacao',
}

export default TipoNegociacaoOferta;
